import {config} from "../../../../definitions/TimelineItems";
import Span from "../../../../components/tag/Span";
import classnames from "classnames";
import TimelineIcon from "../../../timeline/components/TimelineIcon";
import {isPhoneVisit} from "../../../../utils/TimelineUtils";

export const TimelineFrameHeaderEventIcon = ({data}) => {
    let {icon, color} = {...config[data.type]}

    // This is default if none found
    if (!icon && !color) {
        icon = {
            type: 'fa',
            name: 'icon-stethoscope',
        }
        color = 'blue'
    }

    if (data?.config?.type === 'hospitalWard') {
        icon = {
            type: 'custom',
            name: 'hospitalWard',
        }
    }


    if(isPhoneVisit(data)) {
        icon = {
            type: 'custom',
            name: 'phone'
        }
    }


    const checkFaIconStyling = () => {
        const faPrefix = 'timeline-icon-wrapper';
        if(icon.type === 'fa') {
            switch(icon.name) {
                case 'fa-laptop':
                    return `${faPrefix}-laptop`;
                case 'icon-stethoscope':
                    return `${faPrefix}-stethoscope`;
                default:
                    return null;
            }
        }
    };

    return (
        <Span sm-len="2" len="2" style={{position: "relative"}}>
            <div className={classnames('icon-wrapper', 'timeline-icon-wrapper', [checkFaIconStyling()])}>
                <TimelineIcon config={icon} color={color} past={false}/>
            </div>
        </Span>
    );
};